module.exports = __webpack_public_path__ + "img/heat is key.9462a8d1.png";